import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'nickName',
      type: 'input',
      label: '客户昵称',
      clearable: true,
      placeholder: '请输入客户昵称'
    },
    {
      field: 'usedBy',
      type: 'select',
      label: '使用人',
      clearable: true,
      filterable: true,
      placeholder: '请选择使用人'
    },
    {
      field: 'groupId',
      type: 'select',
      label: '部门',
      placeholder: '请选择部门',
      filterable: true,
      clearable: true
    },
    {
      field: 'belongEmpId',
      type: 'input',
      label: '企微账号',
      clearable: true,
      placeholder: '请输企微账号'
    },
    {
      field: 'belongCorpId',
      type: 'select',
      label: '所属主体',
      placeholder: '请选择主体',
      filterable: true,
      clearable: true
    },
    {
      field: 'createdTime',
      type: 'dateTimePicker',
      label: '加入时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间'
      }
    },
    {
      field: 'thirdParty',
      type: 'select',
      label: '第三方',
      clearable: true,
      filterable: true,
      placeholder: '请选择所属第三方'
    },
    {
      field: 'sourceLabel',
      type: 'select',
      label: '来源渠道',
      clearable: true,
      filterable: true,
      placeholder: '请选择来源渠道'
    },
    {
      field: 'takeoverStatus',
      type: 'select',
      label: '接替状态',
      clearable: true,
      options: [
        { title: '全部', value: '' },
        { title: '接替完毕', value: 1 },
        { title: '等待接替', value: 2 },
        { title: '客户拒绝', value: 3 },
        { title: '接替达上限', value: 4 }
      ]
    }
  ]
}
